
import axios from "axios";

export default {
  props: {
    placeholder: {type: String, default: ''},
    searchUrl: {type: String, required: true},
    minSearchLength: {type: Number, default: 1},
    optionIdProp: {type: String, required: true},
    optionTextProp: {type: String, required: true},
    optionSubtextProp: {type: String, default: undefined},
    optionSubtitleProp: {type: String, default: undefined},
    optionUrlProp: {type: String, default: undefined},
  },
emits: ['select'],
  data() {
    return {
      searchValue: '',
      searching: false,
      items: [],
      showDropdown: false,
      abortController: new AbortController(),
      requestId: 0,
    }
  },
  watch: {
    async 'searchValue'() {
      if (this.searchValue.length >= this.minSearchLength) {
        this.abortController.abort();
        this.abortController = new AbortController();
        this.fetchData(this.abortController.signal, ++this.requestId);
      } else {
        this.abortController.abort();
        this.showDropdown = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClicksOutsideComponent);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClicksOutsideComponent);
  },
  methods: {
    fetchData(abortSignal, requestId) {
      this.searching = true;
      axios.get(this.searchUrl, {
        params: {
          q: this.searchValue,
        },
        signal: abortSignal,
      }).then((response) => {
        this.items = response.data.items;
        this.showDropdown = true;
      }).catch((error) => {
        if (error.code === 'ERR_CANCELED' || error.code === 'ECONNABORTED') {
          return;
        } else if (error.status === 403) {
          alert("Suche fehlgeschlagen: Bitte melden Sie sich erneut an.");
        } else {
          alert("Suche fehlgeschlagen.");
        }
        this.items = [];
      }).finally(() => {
        if (requestId === this.requestId) {
          this.searching = false;
        }
      })
    },
    handleClicksOutsideComponent(event) {
      if (this.showDropdown && !this.$el.contains(event.target)) {
        this.showDropdown = false;
      }
    },
    restoreDropdown() {
      if (!this.showDropdown && this.searchValue.length >= this.minSearchLength) {
        this.showDropdown = true;
      }
    }
  },
}
